import { memo } from 'react';

import { renamableElementProps } from '../../PrivateTableView/TableViewItemRenamingContext';
import { BaseTableAssetTitle, type BaseTableAssetTitleProps } from './BaseTableAssetTitle';

export const PrivateTableAssetTitle = memo((props: BaseTableAssetTitleProps) => (
  <BaseTableAssetTitle {...props} additionalProps={renamableElementProps} />
));

PrivateTableAssetTitle.displayName = 'PrivateTableAssetTitle';
